import useMySPHLightbox from "@app/hooks/useMySPHLightbox";
import { isClientSide } from "@helper/utils";
import { useEffect } from "react";

const CAMPAIGN_CODE = "bhRegWallCampaign";

export default function RegWallSignupHandler() {
  const { lightbox } = useMySPHLightbox();
  useEffect(() => {
    if (!isClientSide) return;

    // Function to handle the reg-wall-signup click
    const handleSignupClick = (e: Event) => {
      e.preventDefault();

      lightbox?.initiateLogin(CAMPAIGN_CODE);
    };

    // Function to handle document click
    const handleDocumentClick = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains("web2-reg-wall-signup")) {
        handleSignupClick(e);
      }
    };

    // Add event listener once
    document.addEventListener("click", handleDocumentClick);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [lightbox]);

  return null;
}
